<template>
  <div>
    <div class="hidden-sm-and-down">
      <div class="d-flex justify-center mt-10">
        <img src="../assets/logoipsum-293.svg" />
      </div>
    </div>

    <div class="d-flex justify-center mt-3">
      <h1 class="black--text">Hi! Let's get you started.</h1>
    </div>
    <v-card class="mx-auto mt-4" max-width="450">
      <v-card-title>
        <p>Create account {{ reviewerMode ? " as a reviewer" : "" }}</p>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="register">
          <v-text-field v-model="email" label="Email" type="email" required>
          </v-text-field>
          <v-text-field
            v-model="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            name="input-10-2"
            label="Password"
            hint="At least 8 characters"
            :rules="[
              (v) => !!v || 'Password is required',
              (v) =>
                (v && v.length >= 8) ||
                'Password must be at least 8 characters',
            ]"
            class="input-group--focused"
            @click:append="show = !show"
          >
          </v-text-field>
          <div class="d-flex justify-center mb-4 mt-4">
            <v-btn
              block
              large
              color="primary"
              type="submit"
              :loading="btnLoading"
              :disabled="btnLoading"
            >
              Create{{ reviewerMode ? " reviewer" : "" }} account
            </v-btn>
          </div>
          <span class="red--text ma-0 sa-0">{{ errorMsg }}</span>
          <div v-if="reviewerMode">
            <span> Don't want to be reviewer? Follow this link instead: </span>
            <a href="/register" class="text-decoration-none font-weight-light">
              register as user
            </a>
          </div>
          <div class="d-flex justify-space-between mt-3">
            <div>
              <span> By signing up I agree to the </span>
              <a
                href="/legal#terms-and-conditions"
                class="text-decoration-none font-weight-light"
              >
                terms & conditions
              </a>
              <span class="font-weight-light"> and </span>
              <a
                href="/legal#privacy-policy"
                class="text-decoration-none font-weight-light"
              >
                privacy policy
              </a>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      email: "",
      password: "",
      errorMsg: "",
      btnLoading: false,
      reviewerMode: false,
    };
  },
  methods: {
    async register() {
      if (!this.email || !this.password) {
        this.errorMsg = "Please enter both email and password";
        return;
      }
      if (this.password.length < 8) {
        this.errorMsg = "Password must be at least 8 characters";
        return;
      }
      this.btnLoading = true;
      this.errorMsg = "";
      try {
        await this.$utils.callBackendPost(this, "/pub/register", {
          username: this.email,
          password: this.password,
          reviewer: this.reviewerMode,
        });
        this.$router.push("/confirm-email?email=" + this.email);
      } catch (error) {
        this.errorMsg = error;
      } finally {
        this.btnLoading = false;
      }
    },
  },
  mounted() {
    this.$utils.visit(this);
    if (this.$route.query.mode == "reviewer") {
      this.reviewerMode = true;
    }
  },
};
</script>

<style scoped>
.terms-text {
  font-weight: 400;
}
</style>
